const portfolio = {
  "flagships": [
    {
      "id": "sauna-by-wordware",
      "title": "Sauna by Wordware",
      "status": "published",
      "label": "Agent Intelligence",
      "visual": "intelligence",
      "size": "wide",
      "source": {
        "collection": "experience",
        "slug": "sauna-by-wordware"
      },
      "credit": {
        "label": "Source: sauna.ai",
        "href": "https://sauna.ai/"
      },
      "media": [
        {
          "type": "video",
          "src": "/media/sauna-find-founders.mp4",
          "aspectRatio": "16 / 9",
          "poster": "/media/sauna-find-founders-poster.jpg",
          "ariaLabel": "Sauna product demo from sauna.ai - asking Sauna to find every founding engineer, which sources and scores candidates and proactively builds a review app"
        },
        {
          "type": "video",
          "src": "/media/sauna-recruiting-agent.mp4",
          "aspectRatio": "16 / 9",
          "poster": "/media/sauna-recruiting-agent-poster.jpg",
          "ariaLabel": "Sauna product demo from sauna.ai - one request pulls applicants, scores them, drafts outreach in the user's voice and books screens"
        }
      ],
      "sourceRecord": {
        "slug": "sauna-by-wordware",
        "role": "AI Engineer, Agent Intelligence",
        "company": "Sauna by Wordware (YC S24)",
        "period": "Sep 2026 - Current",
        "summary": "Teaching Sauna, an AI coworker, to think, remember, and act on your behalf.",
        "description": "AI Engineer on the Agent Intelligence team at Sauna by Wordware (YC S24). I work on the core agent - how it reasons, what it remembers, and how it acts across the tools people already use - with a focus on making Sauna proactive, so useful work shows up before you ask for it.",
        "details": "",
        "outcomes": [
          "Building Sauna's proactive layer - the agent notices what needs attention across connected apps like email and calendar, ranks it, and turns it into ready-to-approve suggestions, drafts, and reminders.",
          "Extended how Sauna reaches people, including proactive check-ins over iMessage.",
          "Shipped managed data and decision-model APIs, each paired with an agent skill so Sauna can call them directly.",
          "Working across the agent loop, prompts, model routing, and context and memory efficiency, with an eye on speed, cost, and quality."
        ],
        "metrics": [
          "50+ pull requests merged in the first month, end to end from agent logic to product surface."
        ],
        "link": "https://sauna.ai/",
        "links": {
          "company": "https://sauna.ai/"
        }
      }
    },
    {
      "id": "minerva-intelligence",
      "title": "Minerva Intelligence",
      "status": "published",
      "label": "Founding Engineering",
      "visual": "intelligence",
      "size": "wide",
      "source": {
        "collection": "experience",
        "slug": "minerva-intelligence-ycx25"
      },
      "media": [
        {
          "type": "video",
          "src": "/media/minerva-reconciliation.mp4",
          "aspectRatio": "4 / 3",
          "poster": "/media/minerva-reconciliation-poster.jpg",
          "ariaLabel": "Minerva Intelligence reconciliation product demo"
        },
        {
          "type": "video",
          "src": "/media/minerva-cfoadvisory.mp4",
          "aspectRatio": "4 / 3",
          "poster": "/media/minerva-cfoadvisory-poster.jpg",
          "ariaLabel": "Minerva Intelligence CFO Advisory product demo"
        }
      ],
      "sourceRecord": {
        "slug": "minerva-intelligence-ycx25",
        "role": "Founding Engineer, First Hire",
        "company": "Minerva Intelligence (YCX25)",
        "period": "Jun 2025 - Aug 2026",
        "summary": "Built the AI accountant as founding engineer and first hire.",
        "description": "Founding engineer and first hire at Minerva Intelligence (YCX25), the AI accountant. Built the AI-powered accounting platform and Mars, Minerva's AI-native accounting firm, from the ground up.",
        "details": "",
        "outcomes": [
          "Shipped early platform architecture spanning ingestion, reasoning, and analyst workflow layers.",
          "Defined engineering standards and release process for the initial product team.",
          "Partnered directly with founders to scope roadmap from customer discovery to production features."
        ],
        "metrics": [
          "Built and launched the first production stack as employee #1.",
          "Reduced feature delivery cycle through reusable service patterns and internal tooling."
        ],
        "link": "https://www.tryminerva.ai/",
        "links": {
          "company": "https://www.tryminerva.ai/"
        }
      }
    },
    {
      "id": "mars-accounting",
      "title": "Mars Accounting",
      "status": "published",
      "label": "Founding Engineering",
      "visual": "intelligence",
      "size": "standard",
      "description": "I built Mars at Minerva, its AI-native accounting firm for consumer brands, from core product workflows to the live accounting dashboard.",
      "source": {
        "collection": "experience",
        "slug": "minerva-intelligence-ycx25"
      },
      "media": [
        {
          "type": "video",
          "src": "/media/mars-launch.mp4",
          "poster": "/media/mars-launch-poster.jpg",
          "ariaLabel": "Mars Accounting YC launch video showing the live accounting dashboard"
        },
        {
          "type": "video",
          "src": "/media/mars-product-ui.mp4",
          "poster": "/media/mars-product-ui-poster.jpg",
          "ariaLabel": "Mars Accounting product interface demo"
        }
      ],
      "sourceRecord": {
        "slug": "minerva-intelligence-ycx25",
        "role": "Founding Engineer, First Hire",
        "company": "Minerva Intelligence (YCX25)",
        "period": "Jun 2025 - Aug 2026",
        "summary": "Built the AI accountant as founding engineer and first hire.",
        "description": "Founding engineer and first hire at Minerva Intelligence (YCX25), the AI accountant. Built the AI-powered accounting platform and Mars, Minerva's AI-native accounting firm, from the ground up.",
        "details": "",
        "outcomes": [
          "Shipped early platform architecture spanning ingestion, reasoning, and analyst workflow layers.",
          "Defined engineering standards and release process for the initial product team.",
          "Partnered directly with founders to scope roadmap from customer discovery to production features."
        ],
        "metrics": [
          "Built and launched the first production stack as employee #1.",
          "Reduced feature delivery cycle through reusable service patterns and internal tooling."
        ],
        "link": "https://www.tryminerva.ai/",
        "links": {
          "company": "https://www.tryminerva.ai/"
        }
      }
    },
    {
      "id": "brightlight-health",
      "title": "Brightlight Health",
      "status": "published",
      "label": "AI/ML Engineering",
      "visual": "brightlight",
      "size": "wide",
      "link": "https://www.brightlight.health/",
      "source": {
        "collection": "experience",
        "slug": "brightlight-health"
      },
      "sourceRecord": {
        "slug": "brightlight-health",
        "role": "AI/ML Engineer",
        "company": "Brightlight Health",
        "period": "2025 - 2026",
        "summary": "Built AI features for a clinic EMR, from scheduling to supervisor chart review.",
        "description": "Engineered AI-powered EMR features for allied-health clinics. Built an imitation-learning prototype around the supervisor chart-review workflow, with a privacy-safe dataset pipeline, leakage-free offline evaluation, and a shadow-mode continual learner wired into live routes.",
        "details": "",
        "outcomes": [
          "Shipped a privacy-safe imitation-learning pipeline that predicts supervisor review actions without touching PHI.",
          "Built leakage-free offline evaluation with safety-first metrics before any live exposure.",
          "Deployed a shadow-mode continual-learning loop, inert by default and gated on data-retention sign-off."
        ],
        "metrics": [
          "Honest offline result reported against a strong reviewer-score baseline.",
          "Read-only data access with salted-hash identifiers end to end."
        ],
        "link": "https://www.brightlight.health/",
        "links": {
          "company": "https://www.brightlight.health/"
        }
      }
    },
    {
      "id": "real-time-procedural-vlm",
      "title": "Real-Time Procedural VLM",
      "status": "published",
      "label": "Vision-Language Research",
      "visual": "vlm",
      "size": "tall",
      "description": "A real-time vision-language model that follows repair procedures from egocentric video and surfaces the current step as work unfolds.",
      "media": {
        "type": "video",
        "src": "/media/vlm-procedural-demo.mp4",
        "poster": "/media/vlm-procedural-demo-poster.jpg",
        "ariaLabel": "Egocentric repair footage streamed through the real-time procedural VLM"
      },
      "sourceRecord": null
    },
    {
      "id": "ai-racing-lane-perception",
      "title": "AI Racing Tech / Lane Perception",
      "status": "published",
      "label": "Perception Research",
      "visual": "lane",
      "size": "wide",
      "source": {
        "collection": "experience",
        "slug": "ai-racing-tech"
      },
      "media": {
        "type": "video",
        "src": "/media/airt-telemetry.mp4",
        "poster": "/media/airt-telemetry-poster.jpg",
        "ariaLabel": "AI Racing Tech trackside telemetry and autonomy dashboards"
      },
      "sourceRecord": {
        "slug": "ai-racing-tech",
        "role": "Simulation & Perception Researcher",
        "company": "AI Racing Tech (UC Berkeley)",
        "period": "2023-2024",
        "summary": "Worked on autonomy stack simulation and CI for racing systems.",
        "description": "Indy Autonomous Challenge. Integrated vehicle dynamics, built Azure CI pipelines for ROS2 autonomy stack. Pure Pursuit and Model-Based Control.",
        "details": "",
        "outcomes": [
          "Integrated dynamics and perception modules into a consistent simulation workflow.",
          "Added CI coverage for autonomy stack regressions using Azure pipelines.",
          "Improved controller testing confidence before hardware track runs."
        ],
        "metrics": [
          "Reduced integration regressions through automated ROS2 validation checks.",
          "Shortened simulation-to-test iteration loop for autonomy experiments."
        ],
        "link": "",
        "links": {}
      }
    },
    {
      "id": "lexius-video-intelligence",
      "title": "Lexius / Video Intelligence",
      "status": "published",
      "label": "CV/ML Engineering",
      "visual": "lane",
      "size": "standard",
      "source": {
        "collection": "experience",
        "slug": "lexius"
      },
      "media": [
        {
          "type": "video",
          "src": "/media/lexius-alerts.mp4",
          "poster": "/media/lexius-alerts-poster.jpg",
          "ariaLabel": "Lexius real-time theft detection alerts demo"
        },
        {
          "type": "video",
          "src": "/media/lexius-traceback.mp4",
          "poster": "/media/lexius-traceback-poster.jpg",
          "ariaLabel": "Lexius video traceback following a person through a grocery store"
        }
      ],
      "sourceRecord": {
        "slug": "lexius",
        "role": "CV/ML Intern",
        "company": "Lexius (YCW2026)",
        "period": "2024",
        "summary": "Improved production video classification quality and metrics.",
        "description": "Improved video classification by 5% accuracy and 19% F1-score. Migrated GCP to AWS. Built microservices for model serving.",
        "details": "",
        "outcomes": [
          "Improved model quality through targeted dataset cleanup and evaluation instrumentation.",
          "Migrated key workloads from GCP to AWS with lower inference variance.",
          "Delivered service endpoints that supported faster model iteration and deployment."
        ],
        "metrics": [
          "+5% classification accuracy.",
          "+19% F1-score on production-like validation data.",
          "Lower mean inference latency after migration and service tuning."
        ],
        "link": "https://www.lexius.ai/",
        "links": {
          "company": "https://www.lexius.ai/"
        }
      }
    }
  ],
  "experiments": [
    {
      "id": "ai-eval-infrastructure",
      "title": "AI Eval Infrastructure",
      "status": "published",
      "label": "Eval Infrastructure",
      "visual": "pipeline",
      "size": "wide",
      "source": {
        "collection": "projects",
        "slug": "ai-eval-infrastructure"
      },
      "media": [
        {
          "type": "video",
          "src": "/media/aq-task-executor.mp4",
          "poster": "/media/aq-task-executor-poster.jpg",
          "ariaLabel": "Terminal session submitting a benchmark task, watching parallel Kubernetes agent jobs, and reading per-test results"
        },
        {
          "type": "video",
          "src": "/media/taskcli-demo.mp4",
          "poster": "/media/taskcli-demo-poster.jpg",
          "ariaLabel": "Terminal session of TaskCLI building a task image, validating baseline and golden patches, and grading a solver run"
        }
      ],
      "sourceRecord": {
        "slug": "ai-eval-infrastructure",
        "name": "AI Eval Infrastructure",
        "tech": "Python, FastAPI, Kubernetes, Docker, SQLite, SWE-bench, Terminal-Bench",
        "summary": "An end-to-end evaluation system that packages reproducible coding tasks and runs parallel agents in Kubernetes.",
        "description": "TaskCLI packages SWE-bench-style tasks, builds reproducible Docker images, validates baseline and golden-patch expectations, and runs solvers and grading. Agent Task Executor accepts those bundles, runs N parallel isolated Terminal-Bench agents as Kubernetes Jobs, and aggregates per-test results in SQLite.",
        "details": "",
        "featured": false,
        "caseStudy": null,
        "github": "",
        "links": {}
      }
    },
    {
      "id": "vla-manip",
      "title": "VLA-Manip",
      "status": "published",
      "label": "Robot Learning",
      "visual": "transformer",
      "size": "standard",
      "source": {
        "collection": "projects",
        "slug": "vla-manip"
      },
      "media": {
        "type": "video",
        "src": "/media/vla-manip-libero.mp4",
        "poster": "/media/vla-manip-libero-poster.jpg",
        "ariaLabel": "Grid of LIBERO benchmark manipulation tasks with a Panda arm across kitchen and tabletop scenes"
      },
      "sourceRecord": {
        "slug": "vla-manip",
        "name": "VLA-Manip",
        "tech": "PyTorch, OpenVLA, LIBERO, LoRA, GRPO",
        "summary": "Fine-tuning a 7B vision-language-action model on manipulation, then improving it with RL.",
        "description": "Fine-tunes OpenVLA (a 7B vision-language-action model) on a LIBERO manipulation suite, then improves its success rate with a GRPO-style RL post-training step that uses task success as a verifiable reward.",
        "details": "",
        "featured": false,
        "caseStudy": null,
        "github": "",
        "links": {}
      }
    },
    {
      "id": "robot-viewpoint",
      "title": "Robot Viewpoint Robustness",
      "status": "published",
      "label": "RL Research",
      "visual": "camera",
      "size": "wide",
      "source": {
        "collection": "projects",
        "slug": "robot-viewpoint-rl"
      },
      "media": {
        "type": "video",
        "src": "/media/robot-viewpoint-rollouts.mp4",
        "poster": "/media/robot-viewpoint-rollouts-poster.jpg",
        "ariaLabel": "Panda arm manipulation rollouts in Robosuite shown from a sweep of camera viewpoints, then a grid of four policy evaluation runs"
      },
      "sourceRecord": {
        "slug": "robot-viewpoint-rl",
        "name": "Robot Viewpoint Robustness",
        "tech": "Robosuite, MuJoCo, Behavior Cloning, RL",
        "summary": "How camera viewpoint variation breaks learned manipulation policies, and what fixes it.",
        "description": "Vision-only robot-manipulation study in Robosuite and MuJoCo. Trains behavior-cloning policies on PickPlaceCan with a Panda arm, then measures success against controlled camera offsets to map viewpoint degradation and test camera randomization and RL refinement.",
        "details": "",
        "featured": false,
        "caseStudy": null,
        "github": "",
        "links": {}
      }
    },
    {
      "id": "life-automation-optimization",
      "title": "Life Automation & Optimization",
      "status": "published",
      "label": "Personal Systems",
      "visual": "life-os",
      "size": "standard",
      "source": {
        "collection": "projects",
        "slug": "life-automation-optimization"
      },
      "media": [
        {
          "type": "video",
          "src": "/media/life-os-tour.mp4",
          "poster": "/media/life-os-tour-poster.jpg",
          "ariaLabel": "Scrolling tour of the Life OS dashboard with the Today Feed, focus timer, and planning modules"
        },
        {
          "type": "video",
          "src": "/media/daily-pipeline.mp4",
          "poster": "/media/daily-pipeline-poster.jpg",
          "ariaLabel": "Terminal log of the Daily automation pipeline triaging email, scanning job boards, and drafting content"
        }
      ],
      "sourceRecord": {
        "slug": "life-automation-optimization",
        "name": "Life Automation & Optimization",
        "tech": "Python, Flask, launchd, IMAP, OpenAI API, Local-first",
        "summary": "A local-first system that combines a personal operating dashboard with scheduled daily automation.",
        "description": "A file-backed, private Flask dashboard brings routines, calendar items, email follow-ups, Mandarin study, LeetCode streaks, and focus planning into one place. Scheduled launchd jobs add Gmail triage, job scanning, robotics/AI curation, an OSS contribution workflow, and content drafting, with external services isolated so the system remains testable offline.",
        "details": "",
        "featured": false,
        "caseStudy": null,
        "github": "https://github.com/SergioPeterson/life-os",
        "links": {
          "github": "https://github.com/SergioPeterson/life-os"
        }
      }
    },
    {
      "id": "apex-pixel-gp",
      "title": "Apex Pixel RL",
      "status": "published",
      "label": "RL Racing Agent",
      "visual": "race",
      "size": "standard",
      "source": {
        "collection": "projects",
        "slug": "apex-pixel-gp"
      },
      "media": {
        "type": "video",
        "src": "/media/apex-pixel-gameplay.mp4",
        "poster": "/media/apex-pixel-gameplay-poster.jpg",
        "ariaLabel": "Top-down pixel-art F1 gameplay with race control standings and player telemetry panels"
      },
      "sourceRecord": {
        "slug": "apex-pixel-gp",
        "name": "Apex Pixel RL",
        "tech": "TypeScript, RL, Policy Optimization, Canvas, Playwright",
        "summary": "An RL racing agent trained with policy optimization to win a top-down F1 sim I built as its environment.",
        "description": "Reinforcement-learning racing project. I built a top-down pixel-art F1 simulator as the training environment, then trained a driving policy with policy optimization to lap cleanly, manage gears and tyres, and win races against the field. The sim itself has a TypeScript physics engine, Vitest unit coverage, and Playwright end-to-end race tests.",
        "details": "",
        "featured": false,
        "caseStudy": null,
        "github": "",
        "links": {}
      }
    }
  ]
};

export default portfolio;
